// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__aLpb2","image-cropper":"style_image-cropper__3Bzfw","header":"style_header__2qiAP","footer":"style_footer__yyGe5","react-crop":"style_react-crop__2ourV"};